<template>
  <Modal :id="'cmp-accounting-costs-add_costs'" @cancelled="onCancel">
    <template slot="header"> {{$t('tax_types')}} </template>
    <template slot="body">
      <SearchList
        :id="'tax_type_id'"
        :items="items"
        :keyProperty="'tax_type_id'"
        :label="'tax_name'"
        :placeholder="'Search'"
        :selectionNumber="'radio'"
        @selected="onContactItemClick"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import SearchList from "@dtplugins/search-list/search-list";
import InputField from "@plugins/text-field/input-field";
import TextField from "@plugins/text-field/text-field";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet } from "../../../../utility";
import { CostsService } from "../../services/costs.service";
import { createTV, tv } from "../../../../models/text-value.model";
import { format } from "date-fns";
import Modal from "@dtplugins/modal/modal";
export default {
  components: {
    InputField,
    TextField,
    Modal,
    SearchList,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
      validationResult: {},
      newData: {
        description: "",
        amount: "",
        external_id: 0,
      },
      taxTypes: [],
      invoiceDateMenu: null,
      selectedTour: new Set(),
    };
  },
  mounted: function () {
    this.findTaxTypes();
  },
  watch: {},
  computed: {
    items: function () {
      return this.taxTypes || [];
    },

    isFormValid: function () {
      return this.newData.description;
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onCancel() {
      this.$emit("cancelled");
    },
    findTaxTypes() {
      CostsService.findTaxTypes().then((res) => {
        this.taxTypes = res.data.tax_types;
      });
    },

    onClickOK() {
      let params = {
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        external_table: "booking_tours",
        description: this.newData.description,
        amount: this.newData.amount,
        external_id: this.newData.external_id,
      };

      CostsService.addNewCostSplit(params).then((res) => {
        this[ActionTypes.AccountingCostSplits.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          cost_splits: res.data.cost_splits || [],
        });
        this.onCancel();
      });
    },

    onContactItemClick: function (taxes) {
      const taxe_ids = Array.from(taxes);
      if (taxe_ids && taxe_ids.length > 0) {
        CostsService.updateInvoiceTaxType(
          this.selectedCostsDetails.invoice.invoice_id,
          taxe_ids[0]
        );
        this.onCancel();
      }
    },
    onValidation: function (id, validationResult) {
      // console.log(id, validationResult);
    },
    onTextFieldValueChange: function (name, value) {
      this.newData[name] = value;
      console.log("newData", this.newData);
    },
    onDropdownChange: function (name, value) {
      this.newData[name] = value.value;
    },
  },
};
</script>

<style lang="scss">
.cmp-accounting-costs-add_costs {
  .dt-table2 {
    --body-height: 200px !important;
  }
}
</style>
